import { VariantsEntity } from 'features/product-info';
import { GalleryPhoto, ReviewData } from '../types';

export const enrichGallery = (
  gallery: GalleryPhoto[],
  reviewsCards: ReviewData[],
  variantsModel: VariantsEntity | null,
): GalleryPhoto[] => {
  if (!reviewsCards.length || !variantsModel?.products?.length) {
    return gallery;
  }

  const reviewsMap = new Map<string, ReviewData>();
  reviewsCards.forEach((review) => {
    reviewsMap.set(review.reviewId, review);
  });

  const productsMap = new Map<string, string>();
  variantsModel.products.forEach((product) => {
    productsMap.set(product.productId, product.displayedName);
  });

  return gallery.map((photo) => {
    const review = reviewsMap.get(photo.reviewId);

    const productId = review?.productReviewId ? String(review.productReviewId) : null;
    const displayedName = productId ? productsMap.get(productId) : undefined;

    return {
      ...photo,
      urlOriginal: photo.urlLarge,
      authorName: review?.author?.name,
      displayedName,
    };
  });
};
